import React, { useEffect, useState } from "react";
import { STATIC_FILE_URL } from "../constants";
import { AppBar, Box, Button, Divider, Drawer, Fab, IconButton, List, ListItem, Toolbar, Typography, useMediaQuery, useTheme } from "@mui/material";
import MenuIcon from '@mui/icons-material/Menu';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useNavigate } from "react-router-dom";
import { useThemeMode } from "../colors";
import ThemeToggleSwitch from "./ThemeToggleSwitch";

export const Title = ({ isDesktop }: { isDesktop?: boolean}) => {
  const { colors } = useThemeMode();
  
  return (
    <Box display="flex">
      <Typography
        variant={"h3"}
        component="h3"
        style={{ letterSpacing: "0.02em", ...(isDesktop && { 
          color: colors.text.brand.darkest,
          backgroundClip: "text",
        }) }}
      >
        mappin.studio
      </Typography>
    </Box>
  )
}

export const CTAButton = ({ isSmall }: { isSmall?: boolean }) => {
  const navigate = useNavigate();
  const { colors, mode } = useThemeMode();
  
  return (
    <Button
      variant="contained"
      size={isSmall ? "small" : "medium"}
      onClick={() => navigate("/create")}
      sx={{ boxShadow: mode === "light" ? "2px 2px #808080" : undefined}}
    >
      Create your {isSmall ? "own" : ""} map
    </Button>
  )
}

export const Navbar = () => {
  const theme = useTheme();
  const { colors } = useThemeMode();
  const isSmall = useMediaQuery(theme.breakpoints.down("md"));
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [scrollPosition, setScrollPosition] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const handleScroll = () => {
      const position = window.pageYOffset;
      setScrollPosition(position);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  const startNav = false;

  if (isMobile) {
    // return mobile navbar
    return (
      <>
        <AppBar
          position="sticky"
          sx={{
            bgcolor: startNav ? `${theme.palette.background.default}` : "transparent",
            backdropFilter: startNav ? undefined : "blur(8px)",
            top: 0,
          }}
          elevation={0}
        >
          <Toolbar sx={{ justifyContent: "space-between", my: 0.5, bgcolor: "transparent", backgroundImage: "none" }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <img
                src={`${STATIC_FILE_URL}/pin-icon.png`}
                width="32px"
                height="32px"
                style={{ alignSelf: "center" }}
                alt="mappin-pin"
              />
            </Box>
            <CTAButton isSmall/>
            <IconButton onClick={() => setIsOpen(!isOpen)}>
              <MenuIcon/>
            </IconButton>
          </Toolbar>
        </AppBar>
        <Drawer
          open={isOpen}
          anchor="right"
          PaperProps={{ sx: { bgcolor: theme.palette.background.default, p: 1, alignItems: "center" }}}
          onClose={() => setIsOpen(false)}
        >
          <Title/>
          <Divider flexItem sx={{ mt: 1 }} />
          <List>
            <ListItem>
              <Typography variant="h6">About Us</Typography>
            </ListItem>
            <ListItem>
              <ThemeToggleSwitch compact />
            </ListItem>
            <ListItem>
              <CTAButton isSmall/>
            </ListItem>
          </List>

        </Drawer>
      </>
    );
  }
  return (
    <AppBar
      position="fixed"
      sx={{
        bgcolor: startNav ? "transparent" : `transparent`,
        backdropFilter: startNav ? undefined : "blur(8px)",
        backgroundImage: "none",
        top: 0,
      }}
    >
      <Toolbar sx={{ justifyContent: "space-between", my: isSmall ? 1 : 2, bgcolor: "transparent", backgroundImage: "none", minHeight: "54px" }}>
        <Title isDesktop />
        <Box display="flex" alignItems="center">
          <ThemeToggleSwitch iconOnly />
          <Button sx={{ mr: isSmall ? "1rem" : "2rem", color: theme.palette.text.primary }} size={isSmall ? "small" : "medium"}>
            About Us
          </Button>
          <CTAButton/>
        </Box>
      </Toolbar>
      {startNav && (<Fab sx={{ position: "absolute", top: "90vh", left: "50%", background: colors.background.brand.lightest + "aa" }} href="#features">
        <ExpandMoreIcon fontSize="large" sx={{ color: colors.text.brand.lightest }} />
      </Fab>)}
    </AppBar>
  );
};
